import ScrollToTop from "../../components/ScrollToTop.tsx";
import useDatalayer from "../../components/useDatalayer.tsx";
import WorthToKnowSectionComponent from "../../components/alternative-frontpages/WorthToKnowSectionComponent.tsx";
import WhatYouAreGettingSectionComponent from "../../components/alternative-frontpages/WhatYouAreGettingSectionComponent.tsx";
import WhyChooseHiperSectionComponent from "../../components/alternative-frontpages/WhyChooseHiperSectionComponent.tsx";
import CallMeRTOComponent from "../../components/callMe/CallMeRTOComponent.tsx";
import TDCPaidHeroComponent from "../../components/hero/TDCPaidHeroComponent.tsx";
import setNoIndexMeta from "../../components/setNoIndexMeta.tsx";
import AlternativeFrontpagesTitleAndMetaDescription from "../../components/alternative-frontpages/AlternativeFrontpagesTitleAndMetaDescription.tsx";
import {CallMePhoneNumbers} from "../../util/contact.ts";


export default function TDCPaidPage() {
    ScrollToTop()
    useDatalayer()
    setNoIndexMeta()
    AlternativeFrontpagesTitleAndMetaDescription()

    /* query string contains 99-6mdr-tdc-net || fiber-99-6mdr-hovedstadsomraadet */

    return (
        <div className={"page-campaign-ida"}>
            <TDCPaidHeroComponent/>
            <CallMeRTOComponent phoneNumberSet={CallMePhoneNumbers.Broadband} className={"rto--box page-home"}/>
            <WhatYouAreGettingSectionComponent/>
            <WorthToKnowSectionComponent/>
            <WhyChooseHiperSectionComponent/>
        </div>
    )
}
